// extracted by mini-css-extract-plugin
export default {"whiteBoard":"AlimtalkContentPopover_whiteBoard__Lg5gl","alimtalkButtons":"AlimtalkContentPopover_alimtalkButtons__N9KKl"};